import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=a52fe404&scoped=true&"
import script from "./Share.vue?vue&type=script&lang=ts&"
export * from "./Share.vue?vue&type=script&lang=ts&"
import style0 from "./Share.vue?vue&type=style&index=0&id=a52fe404&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52fe404",
  null
  
)

export default component.exports